import templateUrl from './component.tpl.html';
import AlNavigationTabsComponentController from './controller';

angular.module('festzelt-os.modules.navigation')
    .component('alNavigationTabs', {
        controller: AlNavigationTabsComponentController,
        controllerAs: 'vm',
        templateUrl
    })



// WEBPACK FOOTER //
// ./src/app/modules/navigation/components/al-navigation-tabs/component.js